<script setup lang="ts">
import { ProcessingAnimation } from '@forgd/ui-kit/blocks/animations'
import { Button } from '@forgd/ui-kit/button'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

defineProps<{
  state: 'processing' | 'error'
}>()

defineEmits<{
  (e: 'retry'): void
}>()
</script>

<template>
  <div class="flex h-full w-full flex-col items-center justify-center gap-4 text-center">
    <template v-if="state === 'processing'">
      <ProcessingAnimation size="lg" />
      <div>
        <h1 class="text-lg font-semibold text-primal">
          We are setting up your account...
        </h1>
        <p class="mt-1 text-sm text-secondary text-center">
          This might take a few seconds. <br> Do not close this window.
        </p>
      </div>
    </template>

    <template v-else>
      <ExclamationTriangleIcon class="size-12 text-error" aria-hidden="true" />
      <div>
        <h1 class="text-lg font-semibold text-primal">
          Something went wrong
        </h1>
        <p class="mt-1 text-sm text-secondary">
          We couldn’t finish setting up your account. Please try again.
        </p>
      </div>
      <Button size="lg" @click="$emit('retry')">
        Try again
      </Button>
    </template>
  </div>
</template>
